import { Reducer } from "redux";
import { OrderResponseModel } from "../../models/order-model";
import ORDER_CONSTANTS from "../constants/order-constants";
import { OrderAction } from "../types/order-types";
import { OrderModel } from "../../models/order-model";
export interface OrderReducerState {
  loading: boolean;
  success: boolean;
  successMessage: string;
  error: Array<any>;
  ordersData: OrderResponseModel;
  orderDetail: OrderModel;
  orderCreated: OrderModel;
  errorMessage?: string;
  errorStatus?: number;
  offlineError?: string;
}

const initialState: OrderReducerState = {
  loading: false,
  success: false,
  successMessage: "",
  error: [],
  orderDetail: {} as OrderModel,
  orderCreated: {} as OrderModel,
  errorMessage: "",
  errorStatus: 0,
  offlineError: "",
  ordersData: {
    orders: [],
    limit: 1,
    page: 1,
    pages: 1,
    total: 1,
  },
};

export const orderReducer: Reducer<OrderReducerState, OrderAction> = (
  state = initialState,
  action: OrderAction
) => {
  switch (action.type) {
    //----------CREATE ORDER-----------//
    case ORDER_CONSTANTS.CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ORDER_CONSTANTS.CREATE_ORDER_FAIL:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false,
      };

    case ORDER_CONSTANTS.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        orderCreated: action.data,
        success: true,
        error: [],
        loading: false,
      };

    case ORDER_CONSTANTS.CREATE_ORDER_RESET:
      return {
        ...state,
        success: false,
        error: [],
        loading: false,
        offlineError: "",
        successMessage:""
      };

    case ORDER_CONSTANTS.CREATE_ORDER_OFFLINE:
      return {
        ...state,
        success: false,
        error: [],
        loading: false,
        offlineError: action.error,
      };

    //----------GET ORDERS BY CLIENT-----------//
    case ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
        ordersData: {
          orders: [],
          limit: 1,
          page: 1,
          pages: 1,
          total: 1,
        },
        errorStatus: undefined,
        errorMessage: undefined,
      };

    case ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        errorStatus: action.error.status ?? 400,
        errorMessage: action.error.message ?? "error",
      };

    case ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        ordersData: action.data,
      };

    //----------GET ORDER DETAIL-----------//
    case ORDER_CONSTANTS.GET_ORDERDETAIL_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ORDER_CONSTANTS.GET_ORDERDETAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        errorMessage: action.error,
      };

    case ORDER_CONSTANTS.GET_ORDERDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        orderDetail: action.data,
      };

    //----------CANCEL ORDER DETAIL-----------//
    case ORDER_CONSTANTS.CANCEL_ORDER_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ORDER_CONSTANTS.CANCEL_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        errorMessage: action.error,
      };

    case ORDER_CONSTANTS.CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true,
        orderDetail: action.data,
        successMessage: "La orden fue cancelada correctamente"
      };

    default:
      return state;
  }
};
